/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type ConfigDetailHeader_ConfigFragment = { __typename: 'ConfigurationModel', id: string, state: Types.ConfigurationStatus, site?: { __typename: 'Site', name: string } | null, groups: Array<{ __typename: 'Group', id: string, name: string }> };

export const ConfigDetailHeader_ConfigFragmentDoc = gql`
    fragment ConfigDetailHeader_config on ConfigurationModel {
  id
  site {
    name
  }
  groups {
    id
    name
  }
  state
}
    `;